const features = [
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '全站影片支持1080P高清播放，观影画面清晰细腻，畅享影院级视觉体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不卡',
    desc: '智能CDN加速技术，播放稳定流畅。自动适配网络环境，告别缓冲等待。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '专业片源团队7×24小时不间断更新，热播内容第一时间上线，追剧快人一步。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端适配',
    desc: '电脑、手机、平板均可观看，响应式自适应设计，随时随地畅享影视。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无扰',
    desc: '无需注册、无弹窗广告、无恶意插件。纯净观影环境，保护你的设备安全。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            选择麻花影院免费观看的五大理由
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="group rounded-xl p-5 md:p-6 bg-background-50 border border-background-200/70 hover:border-primary-200 text-center transition-all"
              style={{ animationDelay: `${idx * 100}ms` }}
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-500 transition-colors mb-4">
                <i className={`${feature.icon} text-2xl text-primary-600 group-hover:text-background-50`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}